import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { WishlistProvider } from "./context/WishlistContext";
import { CartProvider } from "./context/CartContext";
import { useCart } from "./context/CartContext";
import Header from "./components/Header";
import CartPopup from "./components/CartPopup";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Wishlist from "./pages/Wishlist.jsx";
import CategoryProducts from "./pages/CategoryProducts";
import ProductDetail from "./pages/ProductDetail";
import Checkout from "./pages/Checkout";
import Address from "./pages/Address";
import Terms from "./components/TermsOfService";
import Privacy from "./components/PrivacyPolicy";
import Refund from "./components/RefundPolicy";
import FAQ from "./components/FAQ";
import About from "./components/About";
import NewCollections from "./pages/NewCollections";
import "./App.css";
import SareeCategory from "./components/SareeCategory";
import OtherCategory from "./components/OtherCategory";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AppContent = () => {
  const { showAddedNotification } = useCart();

  return (
    <div className="App">
      <Header />
      <CartPopup />
      {showAddedNotification && (
        <div className="added-notification">Item added to cart!</div>
      )}
      <div className="routes">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/favourites" element={<Wishlist />} />
          <Route
            path="/category/:categoryName"
            element={<CategoryProducts />}
          />
          <Route path="/products" element={<Products />} />
          <Route path="/product/:productId" element={<ProductDetail />} />
          <Route path="/address" element={<Address />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/about" element={<About />} />
          <Route path="/FAQ" element={<FAQ />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/refund" element={<Refund />} />
          <Route path="/new-collections" element={<NewCollections />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/payment-cancel" element={<PaymentCancel />} />
        </Routes>
      </div>
      <Footer />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};

function App() {
  return (
    <Router>
      <WishlistProvider>
        <CartProvider>
          <AppContent />
        </CartProvider>
      </WishlistProvider>
    </Router>
  );
}

function Products() {
  return (
    <div>
      <div className="category-section">
        <div className="discount-banner">10% Discount</div>
        <SareeCategory />
        <OtherCategory />
      </div>
    </div>
  );
}

export default App;
